exports.SUPPORTED_LOCALES = [
    "en-us",
    "fr-fr",
    "de-de",
    "es-es",
    "es-mx",
    "nl-nl",
    "en-gb",
    "it-it",
    "cs-cz",
    "pl-pl",
    "sv-se",
    "da-dk",
    "fi-fi",
    "nb-no",
    "de-at",
    "en-eu",
    "ja-jp",
    "ko-kr",
    "zh-tw",
    "zh-cn",
    "ro-ro",
    "ru-ru",
    "en-in",
    "en-sg",
    "en-au",
    "tr-tr",
    "fr-be",
    "pt-br",
    "es-la",
    "th-th",
    "id-id",
    "vi-vn",
];

exports.LOCALES_TO_COUNTRIES = {
    "en-us": "United States",
    "fr-fr": "France",
    "de-de": "Germany",
    "es-es": "Spain",
    "nl-nl": "The Netherlands",
    "en-gb": "United Kingdom",
    "it-it": "Italy",
    "cs-cz": "Czech Republic",
    "pl-pl": "Poland",
    "sv-se": "Sweden",
    "da-dk": "Denmark",
    "fi-fi": "Finland",
    "nb-no": "Norway",
    "de-at": "Austria",
    "en-eu": "United Kingdom",
    "ja-jp": "Japan",
    "ko-kr": "Korea",
    "zh-tw": "Taiwan",
    "zh-cn": "China",
    "ro-ro": "Romania",
    "ru-ru": "Russian Federation",
    "en-in": "India",
    "en-sg": "Singapore",
    "en-au": "Australia",
    "tr-tr": "Turkey",
    "fr-be": "Belgium",
    "pt-br": "Brazil",
    "es-la": "Mexico",
    "es-mx": "Mexico",
    "th-th": "Thailand",
    "id-id": "Indonesia",
    "vi-vn": "Viet Nam",
};
